<template>
  <div class="product-carousel-component">
    <VueSlickCarousel v-bind="settings">
      <div class="top-product-item" v-for="(product, index) in products" :key="index">
        <div class="top-product-image">
          <img :src="product.image">
        </div>
        <div class="top-product-text">
          <b>{{ product.name }}</b>
          <div class="top-product-price">Php {{ product.price }}</div>
          <a v-b-modal.top-product-preview @click="getTopProductSlug(product.slug)">VIEW PRODUCT</a>
        </div>
      </div>
    </VueSlickCarousel>
    <TopProductModal :productSlug="productSlug"></TopProductModal>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import TopProductModal from '@/components/store/TopProductModal'

export default {
  name: "Carousel",
  components: { 
    VueSlickCarousel,
    TopProductModal
   },
  props: {
    products: Array
  },
  data() {
    return {
      productSlug: undefined,
      settings: {
        dots: false,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 5,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1560,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 4,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  methods: {
    getTopProductSlug(slug) {
      this.productSlug = slug;
    }
  }
}
</script>

<style lang="sass" scoped>
.top-product-wrap 
  height: 90px
  overflow-x: hidden
  .top-product-item
    display: flex
    align-items: center
    justify-content: center
    height: 90px
    padding: 10px

.top-product-wrap 
  .slick-slide
    &:nth-child(3n-2)
      .top-product-item
        background-color: $dutche-primary-yellow
    &:nth-child(3n-1)
      .top-product-item
        background-color: $dutche-primary-orange
    &:nth-child(3n)
      .top-product-item
        background-color: $dutche-primary-brown

.top-product-image
  width: 60px
  float: left
  margin-right: .8rem
  img
    width: 60px
    height: 60px
    object-fit: cover

.top-product-text
  float: left
  width: 65%
  font-size: .7rem 
  color: $white

  a
    color: $dutche-primary-violet
    font-weight: bold
    display: block
    margin-top: .5rem

    &:hover
      color: $white
      text-decoration: none

@media (min-width: 1920px)
  .top-product-text
    width: 65%
</style>
